import * as React from 'react';

import { RouterProvider } from 'react-router-dom';

import { router } from './router';

const Routes = () => <RouterProvider router={router} />;

export { Routes };
